import {Mapper} from '@s-ui/domain'

export default class FromVehiclesListRawDataToVehiclesListValueObjectMapper extends Mapper {
  constructor({mapper, entity, valueObject}) {
    super()
    this._mapper = mapper
    this._entity = entity
    this._valueObject = valueObject
  }

  map = ({carPlate, plateRegistrationYear, plateRegistrationMonth, vehicles}) => {
    const plateRegistrationDate = plateRegistrationMonth
      ? `${plateRegistrationMonth.toString().padStart(2, '0')}/${plateRegistrationYear}`
      : undefined

    const items = vehicles.map(
      ({
        acceleration,
        bodyType,
        bodyTypeId,
        doors,
        fuelType,
        fuelTypeId,
        length,
        width,
        height,
        hp,
        id,
        imageUrlPath,
        make,
        makeId,
        manufacturerPrice,
        model,
        modelId,
        modelYear,
        price,
        searchUrl,
        transmissionType,
        transmissionTypeId,
        trunkCapacityInLiters,
        url,
        version,
        versionId,
        year
      }) =>
        this._entity({
          acceleration,
          bodyType,
          bodyTypeId,
          carPlate,
          doors,
          fuelType,
          fuelTypeId,
          hp,
          id,
          imageUrlPath,
          make,
          makeId,
          model,
          length,
          width,
          height,
          modelId,
          plateRegistrationDate,
          plateRegistrationYear,
          price: price || manufacturerPrice,
          searchUrl,
          transmissionType,
          transmissionTypeId,
          luggageCapacity: trunkCapacityInLiters,
          url,
          version,
          versionId,
          year: year || modelYear
        })
    )
    return this._valueObject({items})
  }
}
